import * as a from "react";
import s from "../lib/IconBase.es.js";
import n from "../defs/FileMagnifyingGlass.es.js";
const e = a.forwardRef((i, o) => /* @__PURE__ */ a.createElement(s, { ref: o, ...i, weights: n }));
e.displayName = "FileMagnifyingGlassIcon";
const c = e;
export {
  c as FileMagnifyingGlass,
  e as FileMagnifyingGlassIcon,
  e as FileSearchIcon
};
